import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
// components
// @ts-ignore
import { CustomAlertDialog } from "@gl-shared/shared/ui";
// icons
// @ts-ignore
import { premiumFlagIcon } from "@gl-shared/shared/vector";
// helpers
import {
  pagesUrl,
  hotelPanelRootUrl,
  isAddEditOfferPageActive,
  shouldRenderPremiumTrialFlag
} from "../../common/utils/panel-helpers/helpers";
import { leaveProcessNoticeMsg } from "../../pages/Offers/offersHelpers";
// actions
import { useActions } from "../../common/hooks/useActions";
import { loginActionCreators } from "../../pages/Login/loginModule";
import { globalActionCreators } from "../../common/store/modules/globalModule";

const activeItemClass = "category__row category__row--active";
const regularItemClass = "category__row";

const AppSidebar = ({ handleFormMessage }: any) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Alert Dialog data:
  const [pageClickedForDialog, setPageClickedForDialog] = useState("");
  const [isAlertDialogOpen, setIsAlertDialogOpen] = useState(false);
  // END of Alert Dialog data

  // actions
  const logoutUser = useActions(loginActionCreators?.logoutUserAction, []);
  const setSelectedHotels = useActions(globalActionCreators?.setSelectedHotelsAction, []);

  // states
  const hotelUser = useSelector((state: any) => state.home?.hotelData?.hotelUser);
  const isHotelGroupExists = useSelector((state: any) => state.home.isHotelGroupExists);
  const defaultHotelSaasModel = useSelector((state: any) => state.home.defaultHotelSaasModel);
  const isFormChanged = useSelector((state: any) => state.offers.isFormChanged);
  const selectedHotels = useSelector((state: any) => state.global.selectedHotels);
  const hotelGroup = useSelector((state: any) => state.home.hotelData?.hotelGroup);

  // Fires on click on Sidebar item, except on Dashboard or Bookings (for Hotel Panel only)
  // Pre-select first hotel, when user change from "All hotels" view to Single Hotel View
  const handleChangeSelectedHotels = () => {
    if (isHotelGroupExists) {
      // If "All Hotels" is selected or if there are more than 1 selected hotel --> change selectedHotel selection
      if (selectedHotels[0].id === 0 || selectedHotels?.length > 1) {
        // First is "All hotel", so we are pre-selecting next one
        setSelectedHotels([hotelGroup[1]]);
        handleFormMessage("", "HotelSelectionNotice");
      }
    }
  };

  const onSidebarItemClick = (page: string, changeHotel?: boolean) => {
    if (isAddEditOfferPageActive(location?.pathname) && isFormChanged) {
      setPageClickedForDialog(page);
      setIsAlertDialogOpen(true);

      return;
    }

    changeHotel && handleChangeSelectedHotels();
    navigate(`/${hotelPanelRootUrl}/${page}`);
  };

  // Alert Dialog confirmation
  const handleSidebarItemConfirmation = () => {
    setIsAlertDialogOpen(false);
    navigate(`/${hotelPanelRootUrl}/${pageClickedForDialog}`);
  };

  // Alert Dialog cancellation
  const handleCloseAlertDialog = () => setIsAlertDialogOpen(false);

  // logout action
  const onLogoutClick = () => logoutUser(navigate);

  return (
    <div className="navbar-default navbar-static-side" role="navigation">
      <CustomAlertDialog
        isOpen={isAlertDialogOpen}
        handleClose={handleCloseAlertDialog}
        handleBtnLeft={handleCloseAlertDialog}
        handleBtnRight={handleSidebarItemConfirmation}
        title={"CHANGES NOT SAVED"}
        content={leaveProcessNoticeMsg}
        btnLeftLabel={"GO BACK"}
        btnRightLabel={"LEAVE ANYWAY"}
      />
      <div className="sidebar-collapse">
        <ul className="nav metismenu" id="side-menu">
          <div className="hotel-panel__profile">
            <span className="hotel-panel__profile-label">Hotel Panel</span>
            <span className="hotel-panel__profile-name">{hotelUser}</span>
          </div>
          <div className="categories__area">
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.dashboard);
              }}
              className={location?.pathname === `/${hotelPanelRootUrl}/` ? activeItemClass : regularItemClass}
            >
              <div className="category__text">Dashboard</div>
            </div>
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.bookings);
              }}
              className={location?.pathname?.includes(pagesUrl?.bookings) ? activeItemClass : regularItemClass}
            >
              <div className="category__text">Bookings</div>
            </div>
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.offers, true);
              }}
              className={location?.pathname?.includes(pagesUrl?.offers) ? activeItemClass : regularItemClass}
            >
              <div className="category__text">Hotel Offers</div>
            </div>
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.marketplace, true);
              }}
              className={location?.pathname?.includes(pagesUrl?.marketplace) ? activeItemClass : regularItemClass}
            >
              <div className="category__text">Marketplace</div>
            </div>
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.employees, true);
              }}
              className={location?.pathname?.includes(pagesUrl?.employees) ? activeItemClass : regularItemClass}
            >
              <div className="category__text">Employees</div>
            </div>
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.logins, true);
              }}
              className={location?.pathname?.includes(pagesUrl?.logins) ? activeItemClass : "category__row"}
            >
              <div className="category__text">Logins</div>
            </div>
            <div
              onClick={() => {
                onSidebarItemClick(pagesUrl?.settings, true);
              }}
              className={location?.pathname?.includes(pagesUrl?.settings) ? activeItemClass : "category__row"}
            >
              <div className="category__text">Settings</div>
            </div>
            <div className="hotel__logout" onClick={onLogoutClick}>
              <div className={regularItemClass}>
                <div className="category__text">Logout</div>
              </div>
            </div>
          </div>
          {shouldRenderPremiumTrialFlag(isHotelGroupExists, defaultHotelSaasModel, selectedHotels, hotelGroup) && (
            <div className="premium-flag__container">
              <div className="premium-flag__content">
                <p className="premium-flag__header">Premium feature</p>
                <p className="premium-flag__text">
                  Enjoy the hotel panel
                  <br />
                  during your free trial
                </p>
              </div>
              <img className="premium-flag__icon" src={premiumFlagIcon} alt="premium" />
            </div>
          )}
        </ul>
      </div>
    </div>
  );
};

export default AppSidebar;
